import { parse, stringify } from 'uuid';
export var EdgeType;
(function (EdgeType) {
    EdgeType["ANNOTATION"] = "ANNOTATION";
    EdgeType["ATTRIBUTE"] = "ATTRIBUTE";
    EdgeType["CUSTOM"] = "CUSTOM";
})(EdgeType || (EdgeType = {}));
export class Edge {
    id;
    from;
    to;
    type;
    typeName;
    constructor(id, from, to, type, typeName) {
        // TODO is this a valid Edge?
        // if (typeName && type !== EdgeType.CUSTOM) throw
        this.id = stringify(parse(id));
        this.from = stringify(parse(from));
        this.to = stringify(parse(to));
        this.type = type;
        this.typeName = typeName;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRWRnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvcmVjb3JkL0VkZ2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsTUFBTSxNQUFNLENBQUE7QUFFdkMsTUFBTSxDQUFOLElBQVksUUFJWDtBQUpELFdBQVksUUFBUTtJQUNsQixxQ0FBeUIsQ0FBQTtJQUN6QixtQ0FBdUIsQ0FBQTtJQUN2Qiw2QkFBaUIsQ0FBQTtBQUNuQixDQUFDLEVBSlcsUUFBUSxLQUFSLFFBQVEsUUFJbkI7QUFFRCxNQUFNLE9BQU8sSUFBSTtJQUNOLEVBQUUsQ0FBUTtJQUNWLElBQUksQ0FBUTtJQUNaLEVBQUUsQ0FBUTtJQUNWLElBQUksQ0FBVTtJQUNkLFFBQVEsQ0FBUztJQUUxQixZQUNFLEVBQVUsRUFDVixJQUFZLEVBQ1osRUFBVSxFQUNWLElBQWMsRUFDZCxRQUFpQjtRQUVqQiw2QkFBNkI7UUFDN0Isa0RBQWtEO1FBRWxELElBQUksQ0FBQyxFQUFFLEdBQUcsU0FBUyxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFBO1FBQzlCLElBQUksQ0FBQyxJQUFJLEdBQUcsU0FBUyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFBO1FBQ2xDLElBQUksQ0FBQyxFQUFFLEdBQUcsU0FBUyxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFBO1FBQzlCLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFBO1FBQ2hCLElBQUksQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUFBO0lBQzFCLENBQUM7Q0FDRiJ9